import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective } from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';

import { BaseSectionComponent } from '../base-section/base.component';

declare const zE: any;

@Component({
  selector: 'rspl-customer-service-split-landing',
  templateUrl: './customer-service.component.html',
  styleUrl: './customer-service.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, StarRatingModule, MatIcon],
})
export class CustomerServiceSectionComponent extends BaseSectionComponent {
  preview = new URLSearchParams(window.location.search).get('isPreview');

  openZendesk() {
    if (typeof zE !== 'undefined' && !this.preview) {
      zE('messenger', 'open');
    }
  }
}
